import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-roles",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./roles.component.html"
})
export class RolesComponent {}
